import n, { useEffect as ct } from "react";
import { Loading as $e } from "../../../features/common/components/Loading/Loading.js";
import { Modal as d } from "../../../features/common/components/Modal/Modal.js";
import { EnvironmentProvider as ut } from "../../../features/common/hooks/environment/context.js";
import { AuthSharedLanding as mt } from "../SharedLanding/AuthSharedLanding.js";
import { ActionButtonsType as l } from "../shared/actions.enum.js";
import { convertShopLegalToModalLinks as dt } from "../../../features/landing/utils.js";
import { BookingForm as pt } from "./components/BookingForm/BookingForm.js";
import { useWindowEvent as ht } from "../../../features/dom/hooks/useWindowEvent.js";
import { useFacebookPixel as xt } from "../../../features/analytics/hooks/useFacebookPixel.js";
import { useGoogleAnalytics as kt } from "../../../features/analytics/hooks/useGoogleAnalytics.js";
import { useMarketingConsent as vt } from "../../../features/analytics/hooks/useMarketingConsent.js";
import { Status as St } from "../../../../common/shared/status.js";
import { OrderingFormProvider as bt, useOrdering as ft } from "./components/OrderingForm/context.js";
import { BookingProvider as Bt, useBooking as yt } from "./components/BookingForm/context.js";
import { CustomizationProvider as Et } from "./hooks/customization/context.js";
import Lt from "./hooks/customization/useCustomization.js";
import { OrderingForm as Ot } from "./components/OrderingForm/OrderingForm.js";
import Ct from "./hooks/useLandingParameters.js";
function Ft({
  env: a,
  landing: p,
  onLoad: c
}) {
  var E, L, O, C, F, A, P, I, w, _, T, N, K, M, R, z, G, D, H, U, W, j, q, J, Q, V, X, Y, Z, $, ee, te, se, oe, ne, re, ie, ge, le, ae, ce, ue, me, de, pe, he, xe, ke, ve, Se, be, fe, Be, ye, Ee, Le, Oe, Ce, Fe, Ae, Pe, Ie, we, _e, Te, Ne, Ke, Me, Re, ze, Ge, De, He, Ue, We, je, qe, Je, Qe, Ve, Xe, Ye, Ze;
  const {
    isLoading: et,
    configuration: e,
    getTextTranslations: tt,
    getRotativeTranslations: u,
    getActionTranslation: h,
    loader: m,
    lang: o,
    utmReferral: st
  } = Lt(), r = (E = e == null ? void 0 : e.analytics) == null ? void 0 : E.getCodes();
  kt(r == null ? void 0 : r.ga, r == null ? void 0 : r.gtm);
  const ot = vt();
  xt(ot ? r == null ? void 0 : r.pixel : void 0), Ct();
  const {
    active: nt,
    setIsActive: x
  } = yt(), {
    active: rt,
    setIsActive: k
  } = ft();
  ct(() => {
    e !== void 0 && c && c(e);
  }, [e]);
  const { dispatchEvent: v } = ht();
  if (et || e === void 0) return /* @__PURE__ */ n.createElement($e, { design: { color: "#666" } });
  const S = (t, s) => {
    switch (t) {
      case l.ORDER_LINK:
        return {
          type: l.CUSTOM_LINK,
          content: () => k(!0)
        };
      case l.BOOKING:
        return {
          type: l.CUSTOM_LINK,
          content: () => x(!0)
        };
      default:
        return { type: t, content: s };
    }
  }, i = tt("menu"), it = e.settings.configuration.scope.some((t) => {
    var s;
    return ((s = t.services.booking) == null ? void 0 : s.status) === St.ENABLED;
  });
  function b(t, s) {
    return !(t === l.BOOKING && !it || s.length === 0);
  }
  const f = (t, s) => {
    const g = h(s);
    return b(s.type, g) && t.push({
      text: g,
      icon: s.icon,
      primary: s.highlight,
      ...S(s.type, s.content)
    }), t;
  }, B = (t, s) => {
    const g = h(s);
    return b(s.type, g) && t.push({
      text: g,
      ...S(s.type, s.content)
    }), t;
  }, gt = {
    logo: {
      image: e.design.images.logo
    },
    account: {
      actions: ((C = (O = (L = e == null ? void 0 : e.settings) == null ? void 0 : L.user) == null ? void 0 : O.account.actions) == null ? void 0 : C.reduce(B, [])) ?? []
    },
    profile: {
      texts: {
        editionHeader: (_ = (w = (I = (P = (A = (F = e == null ? void 0 : e.settings) == null ? void 0 : F.user) == null ? void 0 : A.account) == null ? void 0 : P.text) == null ? void 0 : I[o]) == null ? void 0 : w.title) == null ? void 0 : _.toString(),
        saveBtn: (z = (R = (M = (K = (N = (T = e == null ? void 0 : e.settings) == null ? void 0 : T.user) == null ? void 0 : N.account) == null ? void 0 : K.text) == null ? void 0 : M[o]) == null ? void 0 : R.save) == null ? void 0 : z.toString(),
        cancelBtn: (j = (W = (U = (H = (D = (G = e == null ? void 0 : e.settings) == null ? void 0 : G.user) == null ? void 0 : D.account) == null ? void 0 : H.text) == null ? void 0 : U[o]) == null ? void 0 : W.cancel) == null ? void 0 : j.toString(),
        emptyTagsNotice: (Y = (X = (V = (Q = (J = (q = e == null ? void 0 : e.settings) == null ? void 0 : q.user) == null ? void 0 : J.account) == null ? void 0 : Q.text) == null ? void 0 : V[o]) == null ? void 0 : X.add_tags) == null ? void 0 : Y.toString(),
        labels: {
          name: (oe = (se = (te = (ee = ($ = (Z = e == null ? void 0 : e.settings) == null ? void 0 : Z.user) == null ? void 0 : $.account) == null ? void 0 : ee.text) == null ? void 0 : te[o]) == null ? void 0 : se.name) == null ? void 0 : oe.toString(),
          surname: (ae = (le = (ge = (ie = (re = (ne = e == null ? void 0 : e.settings) == null ? void 0 : ne.user) == null ? void 0 : re.account) == null ? void 0 : ie.text) == null ? void 0 : ge[o]) == null ? void 0 : le.surname) == null ? void 0 : ae.toString(),
          phone: (he = (pe = (de = (me = (ue = (ce = e == null ? void 0 : e.settings) == null ? void 0 : ce.user) == null ? void 0 : ue.account) == null ? void 0 : me.text) == null ? void 0 : de[o]) == null ? void 0 : pe.phone) == null ? void 0 : he.toString(),
          email: (fe = (be = (Se = (ve = (ke = (xe = e == null ? void 0 : e.settings) == null ? void 0 : xe.user) == null ? void 0 : ke.account) == null ? void 0 : ve.text) == null ? void 0 : Se[o]) == null ? void 0 : be.email) == null ? void 0 : fe.toString(),
          language: (Ce = (Oe = (Le = (Ee = (ye = (Be = e == null ? void 0 : e.settings) == null ? void 0 : Be.user) == null ? void 0 : ye.account) == null ? void 0 : Ee.text) == null ? void 0 : Le[o]) == null ? void 0 : Oe.language) == null ? void 0 : Ce.toString(),
          gender: (_e = (we = (Ie = (Pe = (Ae = (Fe = e == null ? void 0 : e.settings) == null ? void 0 : Fe.user) == null ? void 0 : Ae.account) == null ? void 0 : Pe.text) == null ? void 0 : Ie[o]) == null ? void 0 : we.gender) == null ? void 0 : _e.toString(),
          birthday: (ze = (Re = (Me = (Ke = (Ne = (Te = e == null ? void 0 : e.settings) == null ? void 0 : Te.user) == null ? void 0 : Ne.account) == null ? void 0 : Ke.text) == null ? void 0 : Me[o]) == null ? void 0 : Re.birthday) == null ? void 0 : ze.toString(),
          zipCode: (je = (We = (Ue = (He = (De = (Ge = e == null ? void 0 : e.settings) == null ? void 0 : Ge.user) == null ? void 0 : De.account) == null ? void 0 : He.text) == null ? void 0 : Ue[o]) == null ? void 0 : We.post_code) == null ? void 0 : je.toString(),
          tags: (Ye = (Xe = (Ve = (Qe = (Je = (qe = e == null ? void 0 : e.settings) == null ? void 0 : qe.user) == null ? void 0 : Je.account) == null ? void 0 : Qe.text) == null ? void 0 : Ve[o]) == null ? void 0 : Xe.tags) == null ? void 0 : Ye.toString()
        }
      }
    },
    ...e.settings.menu.enabled ? {
      menu: {
        icon: e.design.images.menuIcon,
        props: {
          modalLinks: dt(e.shop.settings.legal),
          showSeeProfileLink: e.settings.user.account.showLink,
          sections: e.settings.menu.sections.reduce(B, []),
          socials: e.settings.menu.socialNetworks.map((t) => ({
            url: t.url,
            rss: t.type,
            img: t.icon
          })),
          texts: {
            guestLabel: i == null ? void 0 : i.text,
            login: i == null ? void 0 : i.login_link,
            logout: i == null ? void 0 : i.sign_out_link
          }
        }
      }
    } : {}
  }, y = {
    backgroundImage: e.design.images.background,
    background640x1100: (Ze = e.design.images) == null ? void 0 : Ze.background640x1100,
    design: {
      font: e.design.fontFamily,
      general: e.design.colors.general,
      startPage: e.design.colors.startPage
    },
    navbar: gt
  }, lt = {
    ...y,
    rotative: {
      titles: u("guest", "titles"),
      subtitles: u("guest", "subtitles")
    },
    buttons: e.settings.guest.actions.reduce(f, [])
  }, at = {
    ...y,
    rotative: {
      titles: u("user", "titles"),
      subtitles: u("user", "subtitles")
    },
    buttons: e.settings.user.actions.reduce(f, [])
  };
  return /* @__PURE__ */ n.createElement(
    mt,
    {
      env: a,
      scope: e.scope,
      authScope: e.getBaseScope(),
      guest: lt,
      authenticated: at,
      portalId: e.portalId,
      utmReferral: st
    },
    /* @__PURE__ */ n.createElement(
      d,
      {
        show: rt,
        onClose: () => k(!1),
        onOpen: () => v("FormOpened"),
        design: {
          backgroundColor: e.design.colors.general.highlightBackground,
          textColor: e.design.colors.general.highlightText,
          fontFamily: e.design.fontFamily
        }
      },
      /* @__PURE__ */ n.createElement(Ot, null)
    ),
    /* @__PURE__ */ n.createElement(
      d,
      {
        show: nt,
        showCloseBtn: !1,
        onClose: () => x(!1),
        onOpen: () => v("BookingFormOpened"),
        design: {
          backgroundColor: e.design.colors.general.highlightBackground,
          textColor: e.design.colors.general.highlightText,
          fontFamily: e.design.fontFamily
        }
      },
      /* @__PURE__ */ n.createElement(pt, null)
    ),
    /* @__PURE__ */ n.createElement(
      d,
      {
        show: m !== null,
        showCloseBtn: !1,
        design: {
          backgroundColor: e.design.colors.general.primaryButtonBackground,
          textColor: e.design.colors.general.primaryButtonText,
          fontFamily: e.design.fontFamily
        }
      },
      /* @__PURE__ */ n.createElement(
        $e,
        {
          design: {
            color: e.design.colors.general.primaryButtonText,
            backgroundColor: e.design.colors.general.primaryButtonBackground
          },
          text: m == null ? void 0 : m.text,
          fullScreen: !1
        }
      )
    )
  );
}
function Qt(a) {
  const {
    env: p,
    landing: c
  } = a;
  return /* @__PURE__ */ n.createElement(ut, { env: p }, /* @__PURE__ */ n.createElement(Et, { landing: c }, /* @__PURE__ */ n.createElement(bt, null, /* @__PURE__ */ n.createElement(Bt, null, /* @__PURE__ */ n.createElement(Ft, { ...a })))));
}
export {
  Qt as ShopLanding,
  Ft as ShopLandingWrapper
};
//# sourceMappingURL=ShopLanding.js.map
